module.exports = __webpack_public_path__ + "resources/img/img_datahunt6.3ea970c3e1dfa4a387c6695977626de8.png";